import Cookies from 'js-cookie'
// cookie 有效期 4小时
let expires = new Date(new Date().getTime() + 4 * 60 * 60 * 1000)
export default {
    getToken: function() {
        let token = Cookies.get('token')
        if (typeof(token) !== 'undefined' && token !== '') {
            this.setToken(token)
        }
        return token
    },
    setToken: function(val) {
        Cookies.set('token', val, { expires: expires })
    },
    removeToken: function() {
        Cookies.remove('token')
    },
    // token 过期操作
    tokenTimeOut: function() {
        this.removeToken()
        location.reload()
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/tools.js